import { ProgressBar, OverlayTrigger, Tooltip } from "react-bootstrap";

function RevenueOutstandingDuration({ chart_data }) {
  const total = chart_data?.[0];
  const total_issues = total?.total_amount;
  const percentage_30 = total_issues > 0 ? (total?.days_0_30 / total_issues) * 100 : 0;
  const percentage_90 = total_issues > 0 ? (total?.days_31_90 / total_issues) * 100 : 0;
  const percentage_180 = total_issues > 0 ? (total?.days_91_180 / total_issues) * 100 : 0;
  const percentage_360 = total_issues > 0 ? (total?.days_181_360 / total_issues) * 100 : 0;
  const percentage_360_plus = total_issues > 0 ? (total?.days_360_plus / total_issues) * 100 : 0;
  return (
    <>
      <div className="justify-content-center">
        <p className="fs-15 fw-light mb-0 text-muted">
          0-30 days
          <span className="float-end fs-12 fw-normal">
            {`₹ ${total?.days_0_30} Cr`}
          </span>
        </p>
        <OverlayTrigger placement="top" overlay={ <Tooltip>{((total?.days_0_30 / total_issues) * 100).toFixed(2)}%</Tooltip> }>
          <ProgressBar
            className="custom-progress mb-2"
            max={100}
            variant={"success"}
            now={`${(total?.days_0_30 / total_issues) * 100}`}
            label={percentage_30 > 10 ? `${percentage_30.toFixed(2)}%` : null}
          />
        </OverlayTrigger>
 
        <p className="fs-15 fw-light mb-0 text-muted">
          30-90 days
          <span className="float-end fs-12 fw-normal">
            {`₹ ${total?.days_31_90} Cr`}
          </span>
        </p>
        <OverlayTrigger placement="top" overlay={ <Tooltip>{((total?.days_31_90 / total_issues) * 100).toFixed(2)}%</Tooltip> }>
          <ProgressBar
            className="custom-progress mb-2"
            max={100}
            variant={"info"}
            now={`${(total?.days_31_90 / total_issues) * 100}`}
            label={percentage_90 > 10 ? `${percentage_90.toFixed(2)}%` : null}
          />
        </OverlayTrigger>
        
        <p className="fs-15 fw-light mb-0 text-muted">
          90-180 days
          <span className="float-end fs-12 fw-normal">
            ₹ {total?.days_91_180} Cr
          </span>
        </p>
        <OverlayTrigger placement="top" overlay={ <Tooltip>{((total?.days_91_180 / total_issues) * 100).toFixed(2)}%</Tooltip> }>
          <ProgressBar
            className="custom-progress mb-2"
            max={100}
            variant={"warning"}
            now={`${(total?.days_91_180 / total_issues) * 100}`}
            label={percentage_180 > 10 ? `${percentage_180.toFixed(2)}%` : null}
          />
        </OverlayTrigger>
        
        <p className="fs-15 fw-light mb-0 text-muted">
          180-360 days
          <span className="float-end fs-12 fw-normal">
            ₹ {total?.days_181_360} Cr
          </span>
        </p>
        <OverlayTrigger placement="top" overlay={ <Tooltip>{((total?.days_181_360 / total_issues) * 100).toFixed(2)}%</Tooltip> }>
          <ProgressBar
            className="custom-progress mb-2"
            max={100}
            variant={"#F28E2B"}
            now={`${(total?.days_181_360 / total_issues) * 100}`}
            label={percentage_360 > 10 ? `${percentage_360.toFixed(2)}%` : null}
          />
        </OverlayTrigger>
        
        <p className="fs-15 fw-light mb-0 text-muted">
          360+ days
          <span className="float-end fs-12 fw-normal">
            ₹ {total?.days_360_plus} Cr
          </span>
        </p>
        <OverlayTrigger placement="top" overlay={ <Tooltip>{((total?.days_360_plus / total_issues) * 100).toFixed(2)}%</Tooltip> }>
          <ProgressBar
            className="custom-progress"
            max={100}
            variant="danger"
            now={(total?.days_360_plus / total_issues) * 100 || 0}
            label={percentage_360_plus > 10 ? `${percentage_360.toFixed(2)}%` : null}
          />
        </OverlayTrigger>
      </div>
    </>
  );
}

export default RevenueOutstandingDuration;
